// redux/index.js
import { combineReducers } from 'redux';

import searchSlice from './searchBar/searchSlice.js';
import stockReducer from './stockData/nasdaq/stockDataReducer.js';
import { sentimentReducer } from './stockSentiment/SentimentReducer.js';
import profileSlice from './user/profile/profileReducer.js';
import postsSlice from './posts/postReducer.js';
import publicUserPostsSlice from './posts/profilePublicPosts/publicUserPostsSlice.js'
import userProfilePicture from './user/profilePictures/userProfilePicturesReducer.js';
import groupReducer from './userGroups/groups/groupReducer.js';
import commentsSlice from './comments/commentReducer.js';
import profilepublicReducer from './user/publicProfile/userPublicProfileReducer.js';
import { polygonstockReducer } from './polygon/polygonReducer.js';
import authSlice from './authentication/utils/core/authslice.js';
import gamificationSlice from './gamification/gamificationUserSlice.js';
import portfolioSlice from './portfolio/portfolioSlice.js';
import trendingSlice from './trending/trendingSliceReducer.js';
import alertsSlice from './notifications/notificationsSliceReducer.js';
import groupPostSlice from './userGroups/groupPost/groupPostSlice.js'
import stockGroupsSlice from './userGroups/groupsToStock/groupsToStocksSlice.js'
import usernotificationsSlice from './notifications/notificationsSliceReducer.js';
import adminSlice from './admin/adminSlice.js';
import stockIconsSlice from './iconStocks/iconStocksReducerSlice.js';
import marketSnapshotSlice from './stockData/marketSnapshot/marketSnapshotSlice.js';
import edgarReducer from './stockData/edgar/edgarSlice.js'
import watchlistSlice from './user/watchlist/watchlistSlice.js'
import nasdaqIndexSlice from './stockData/nasdaqIndex/nasdaqIndexSlice.js'
import credibilitySlice from './credibility/credibilitySlice.js'
import monetizationSlice from './monetization/monetizationSlice.js'
import credentialQuizSlice from './credentialQuiz/credentialQuizSlice.js'
import credibilityChipSlice from './credibility/credibilityChipsDisplay/credibilityChipSlice.js'
import moderationSlice from './admin/adminModerationSlice.js'
import newsSlice from './news/newsSlice.js'
import userFollowReducer from './user/following/userFollowReducerSlice.js'
import sentimentAggSlice from './sentimentAggregator/sentimentAggSlice.js'
import reportSlice from './report/reportSlice.js'
import authRecoverySlice from './authentication/utils/core/authRecoverySlice.js'
import stockerSignalSlice from './stockerSignal/stockerSignalSlice.js'
import contextRadarSlice from './contextRadar/contextRadarSlice.js'
import postEvidenceReducer from "./posts/postEvidence/postEvidenceSlice.js";
import languageSlice from './settingsPages/language/languageSlice.js';
import accessibilitySlice from './settingsPages/accessibility/accessibilitySlice.js';
import userDataSlice from './settingsPages/userData/userDataSlice.js';
import helpcenterSlice from './settingsPages/helpcenter/helpcenterSlice.js';
import emailPreferencesSlice from './settingsPages/emailPreferences/emailPreferencesSlice.js';
import securitySlice from './settingsPages/security/securitySlice.js';
import legalConsentSlice from './settingsPages/legalConsent/legalConsentSlice.js';
import featureFlagsSlice from './featureFlags/featureFlagsSlice.js';
import roadmapSlice from './admin/roadmapSlice.js';
import meetingNotesSlice from './admin/meetingNotesSlice.js';
import teamMeetingsSlice from './admin/teamMeetingsSlice.js';
import statusMapSlice from './admin/statusMapSlice.js';
import tasksSlice from './admin/tasksSlice.js';
import orgRolesSlice from './admin/orgRolesSlice.js';
import contentReviewSlice from './contentReview/contentReviewSlice.js';
import stockAlertsSlice from './alerts/userStockAlertsSlice.js';
import savedPostsSlice from './savedPosts/savedPostsSlice.js';

//ui slice only for global add ticker search
import uiSlice from './ui/uiSlice.js'

const rootReducer = combineReducers({
 // --- Authentication & User ---
  auth: authSlice, 
  authRecovery: authRecoverySlice,
  profile: profileSlice,
  profilepublic: profilepublicReducer,
  profilePictures: userProfilePicture,
  userFollow: userFollowReducer,
  watchlist: watchlistSlice,

  // --- User Content ---
  // Always registered regardless of the `posts` feature flag: the flag now loads
  // asynchronously from the backend (see redux/featureFlags/), so it can't gate
  // which reducers exist at module-eval time the way the old hardcoded
  // featureFlags.js object could. Gating now happens only at the route/UI level
  // (see routes.js, MobileBottomBar.jsx, leftSideBar.jsx) via the featureFlags slice.
  posts: postsSlice,
  publicUserPosts: publicUserPostsSlice,
  postEvidence: postEvidenceReducer,
  comments: commentsSlice,
  groups: groupReducer,
  groupPosts: groupPostSlice,
  stockGroups: stockGroupsSlice,
  reports: reportSlice,

  // --- Stocks & Market Data ---
  stockData: stockReducer,
  marketSnapshot: marketSnapshotSlice,
  indices: nasdaqIndexSlice,
  openClose: polygonstockReducer,
  stockLogo: stockIconsSlice,
  edgar: edgarReducer,
  sentiment: sentimentReducer,
  sentimentAgg: sentimentAggSlice,
  
  // ------------------------------------------------------
  // STOCKER INTELLIGENCE LAYER
  // (Composite Signal + Context Radar)
  // ------------------------------------------------------
  stockerSignal: stockerSignalSlice,
  contextRadar: contextRadarSlice,

  // --- Gamification, Credibility & Portfolio ---
  gamification: gamificationSlice,
  credibility: credibilitySlice,
  credibilityChips: credibilityChipSlice,
  monetization: monetizationSlice,
  credentialQuiz: credentialQuizSlice,
  portfolios: portfolioSlice,
  news: newsSlice,

  // --- Notifications & Alerts ---
  // NOTE: `alerts` (below) is notificationsSliceReducer.js, not this slice --
  // userStockAlertsSlice.js is a separate, unrelated feature (price alerts on
  // a stock) that was never mounted anywhere; keyed distinctly as
  // `stockAlerts` to avoid clobbering the existing `alerts` key.
  alerts: alertsSlice,
  notifications: usernotificationsSlice,
  stockAlerts: stockAlertsSlice,
  savedPosts: savedPostsSlice,

  // --- Admin & Moderation ---
  admin: adminSlice,
  moderation: moderationSlice,
  roadmap: roadmapSlice,
  meetingNotes: meetingNotesSlice,
  teamMeetings: teamMeetingsSlice,
  statusMap: statusMapSlice,
  tasks: tasksSlice,
  orgRoles: orgRolesSlice,
  contentReview: contentReviewSlice,

  // --- Search & Trending ---
  search: searchSlice,
  trending: trendingSlice,

  // --- Settings Pages ---
  language: languageSlice,
  accessibility: accessibilitySlice,
  userData: userDataSlice,
  helpcenter: helpcenterSlice,
  emailPreferences: emailPreferencesSlice,
  security: securitySlice,
  legalConsent: legalConsentSlice,

  // --- Feature Flags (DB-backed, replaces the old hardcoded redux/featureFlags.js) ---
  featureFlags: featureFlagsSlice,

  // --- UI State (global, non-domain) ---
  ui: uiSlice,


  // Add other reducers here if needed
});


export default rootReducer;
